import confirmAndDeleteAnalysisView from 'analysis-tool/confirmAndDeleteAnalysisView';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {checkCanModifyStep} from 'analysis-tool/EditStepHelpers';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {PipelineGraphQL, PipelineViewGraphQL} from 'pipelines/PipelineTypes';

export default function getDeleteViewAction(
  analysis: PipelineGraphQL,
  view: PipelineViewGraphQL,
  analysisClientStateId: string
): OverflowDataViewAction | null {
  if (isAnalysisReadOnly(analysis)) {
    return null;
  }

  const firstStep = view.lineage[0].step;
  const {canEdit, message} = checkCanModifyStep(analysis, firstStep.id, 'view', 'delete');

  return {
    icon: 'delete',
    onClick: () =>
      confirmAndDeleteAnalysisView({
        analysis,
        stepId: firstStep.id,
        stepType: firstStep.stepType,
        analysisClientStateId,
        typeName: 'view',
      }),
    label: `Delete view`,
    isDisabled: !canEdit,
    helpText: !canEdit ? message : undefined,
  };
}
